import Box from "ds/components/Box";
import ListEntitiesItemDescriptionMultipleLines from "components/ListEntitiesItem/Description/MultipleLines";

import { CellComponentProps } from "../types";

type UserRolesListItemDescriptionCellProps = CellComponentProps;

const UserRolesListItemDescriptionCell = ({
  roleBinding,
}: UserRolesListItemDescriptionCellProps) => {
  if (!roleBinding.role.description) {
    return null;
  }

  return (
    <Box direction="row" align="center">
      <ListEntitiesItemDescriptionMultipleLines
        lines={1}
        hasChevronLink
        description={roleBinding.role.description}
      />
    </Box>
  );
};

export default UserRolesListItemDescriptionCell;
